import React, { useState } from "react";
import InputSearch from "../InputSearch";
import MarketCard from "./MarketCard";

const MarketPlace = () => {
  
  const [isOpen, setIsOpen] = useState(false);

  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const dummy = [
    1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28
  ]

  return (
    <div>
      <div className="-mt-20 w-full bg-pinkColor fixed z-50 gap-y-2 flex flex-col justify-center items-center">
        <InputSearch placeholder="Search" />
      </div>
      <div className="mt-20 flex flex-col justify-end items-center">
      <button
        id="dropdownDefaultButton"
        onClick={toggleDropdown}
        className="border border-slate-700 bg-grayColor focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded text-sm px-5 py-1.5 text-center text-slate-700 inline-flex items-center"
        type="button"
      >
        Dropdown button{' '}
        <svg
          className="w-2.5 h-2.5 ms-3"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 10 6"
        >
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="m1 1 4 4 4-4"
          />
        </svg>
      </button>
      {/* Dropdown menu */}
      <div
        id="dropdown"
        className={`z-10 ${isOpen ? '' : 'hidden'} bg-white divide-y divide-gray-100 rounded-lg shadow w-44 text-slate-700`}
      >
        <ul
          className="py-2 text-sm text-slate-700 dark:text-gray-200"
          aria-labelledby="dropdownDefaultButton"
        >
          <li>
            <div
              // href="#"
              className="block px-4 py-2  text-slate-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white"
            >
              Dashboard
            </div>
          </li>
          {/* Add more menu items */}
        </ul>
      </div>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7 mb-10 justify-center">
  {
    dummy.map(num => <MarketCard />)
  }
</div>

    </div>
  );
};

export default MarketPlace;
